var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0085 10.3334C9.65853 10.3334 9.30854 10.2667 8.9752 10.1417L3.39187 7.99169C2.89187 7.80003 2.5752 7.32503 2.5752 6.79169C2.5752 6.25836 2.9002 5.7917 3.4002 5.60003L8.9752 3.4667C9.64187 3.20837 10.3669 3.2167 11.0335 3.4667L16.6252 5.6167C17.1252 5.80837 17.4419 6.27503 17.4419 6.80836C17.4419 7.3417 17.1169 7.80837 16.6169 8.00004L11.0335 10.1334C10.7002 10.2584 10.3502 10.325 10.0085 10.325V10.3334ZM9.5752 8.58337C9.85854 8.6917 10.1585 8.6917 10.4419 8.58337L15.0752 6.80836L10.4335 5.02503C10.1585 4.9167 9.85019 4.9167 9.56686 5.02503L4.93353 6.80003L9.5752 8.58337Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 13.5168C9.84161 13.5168 9.68328 13.4918 9.53328 13.4335L3.01661 10.9335C2.58327 10.7668 2.37494 10.2835 2.53327 9.85847C2.69994 9.43347 3.18328 9.2168 3.60828 9.37513L9.99994 11.8251L16.3916 9.37513C16.8249 9.20847 17.2999 9.42513 17.4666 9.85847C17.6333 10.2918 17.4166 10.7668 16.9833 10.9335L10.4666 13.4335C10.3166 13.4918 10.1583 13.5168 9.99994 13.5168Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 16.7252C9.84161 16.7252 9.68328 16.7002 9.53328 16.6419L3.01661 14.1419C2.58327 13.9752 2.37494 13.4919 2.53327 13.0669C2.69994 12.6335 3.18328 12.4252 3.60828 12.5835L9.99994 15.0335L16.3916 12.5835C16.8249 12.4169 17.2999 12.6335 17.4666 13.0669C17.6333 13.5002 17.4166 13.9752 16.9833 14.1419L10.4666 16.6419C10.3166 16.7002 10.1583 16.7252 9.99994 16.7252Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.7fc663508d69de17c823b2c84b12a1cf.svg";
export { ForwardRef as ReactComponent };